import * as yup from "yup";

export default yup.object({
  trackingCode: yup
    .string()
    .matches(/^AVC-(?:1[0-9]|[2-9][0-9])-(?:Fi|Oa|Im|Aq|Ha|Pr|Oi)(?:-\d{4}){6}$/, "فرمت کد رهگیری محصول نادرست است."),
});
